import { Controller } from "@hotwired/stimulus"
// Import Flowbite's Modal class. Adjust the import path if needed based on your setup.
import { Modal } from 'flowbite'

export default class extends Controller {
  connect() {
    // Only initialize if not already initialized
    if (!this.element._flowbiteModal) {
      const modal = new Modal(this.element)
      this.element._flowbiteModal = modal
    }
  }

  open(event) {
    event.preventDefault()
    if (this.element._flowbiteModal) {
      this.element._flowbiteModal.show()
    }
  }

  close(event) {
    event.preventDefault()
    if (this.element._flowbiteModal) {
      this.element._flowbiteModal.hide()
    }
  }
} 